import { ITrainersContent } from '@/types/trainers';
import MetaDataIcon from '@/components/ui/icons/trainers/MetaDataIcon';
import { useUser } from '@/hooks/useUser';
import * as Typography from '@/components/shadcn/typography';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/shadcn/popover';
import LatLng from './LatLng';

interface PrettyPrintJsonProps {
  jsonData: Record<string, any>;
}

interface Props {
  data?: ITrainersContent | null;
  lat?: number;
  lon?: number;
}

const PrettyPrintJson: React.FC<PrettyPrintJsonProps> = ({ jsonData }) => (
  <div className="overflow-x-scroll">
    <pre>{JSON.stringify(jsonData, null, 4).replace(/(.{60})/g, '$1\n')}</pre>
  </div>
);

export default function Metadata({ data, lat, lon }: Props) {
  const {
    metadata,
    detectionsByFrame,
    consensusValuesByDetection,
    closeFrames,
    frames,
    guesses,
    ...cleanedData
  } = data || {};
  const { user } = useUser();

  const isAtLeastAdvancedReviewer = user?.admin || user?.advancedReviewer;

  if (!isAtLeastAdvancedReviewer) {
    return null;
  }

  return (
    <>
      <Popover>
        <PopoverTrigger>
          <MetaDataIcon className="fill-neutral-0" />
        </PopoverTrigger>
        <PopoverContent className="max-h-[90vh] overflow-y-auto p-4 text-xs">
          <div>
            {lat && lon ? <LatLng lat={lat} lon={lon} /> : null}
            {data ? (
              <>
                {data?.guesses ? (
                  <>
                    <Typography.H6>Guesses:</Typography.H6>
                    <PrettyPrintJson
                      jsonData={data.guesses.sort(
                        (a: any, b: any) =>
                          new Date(b?.createdAt).getTime() -
                          new Date(a?.createdAt).getTime(),
                      )}
                    />
                  </>
                ) : null}
                {'leaseId' in cleanedData && (
                  <a
                    href={`/api/admin/lease/${cleanedData.leaseId}`}
                    target="_blank"
                    rel="noreferrer">
                    🔗 View Lease Details
                  </a>
                )}
                <Typography.H6>Content:</Typography.H6>
                <PrettyPrintJson jsonData={cleanedData} />
              </>
            ) : null}
          </div>
        </PopoverContent>
      </Popover>
    </>
  );
}
